// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xWZ5","icon":"styles_icon__1tm2i"};